// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"helpDocuments_wrapper__uhNaF","teamViewer":"helpDocuments_teamViewer__26gJL","itemWrapper":"helpDocuments_itemWrapper__2sBXP"};